/* Furniture Instore — PDP v5, beds.
   Colour family pills, and the side drawers behind the Divan storage, Headboard and
   Mattress rows (snippets/fi-bed-part.liquid).

   A confirmed choice is written to the row's hidden [data-fi-addon] checkbox. That is
   the contract fi-pdp-v5.js already reads for the sofa add-ons, so Add to Basket, Buy
   Now and every price in the buttons and the sticky bar follow without a second cart
   path. This file only owns the drawers and the choices. */
(function () {
  'use strict';

  if (window.FIBed && window.FIBed.booted) return;
  window.FIBed = { booted: true };

  /* Product id chosen per row, keyed by block id. The rows are re-rendered on every
     variant change (the price of each option depends on the bed's size), and this is
     what carries the customer's choice across to the new markup. */
  var chosen = {};
  var token = newToken();

  function newToken() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  function money(cents, trim) {
    var value = (cents / 100).toFixed(2);
    if (trim && value.slice(-3) === '.00') value = value.slice(0, -3);
    var fmt = window.FIPDP && window.FIPDP.moneyFormat;
    if (!fmt) return '£' + value;
    return fmt.replace(/<[^>]*>/g, '').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  }

  function rows() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-fi-bed-option]'));
  }

  function rowInput(row) {
    return row.querySelector('[data-fi-bed-input]');
  }

  function rowDialog(row) {
    return row.querySelector('[data-fi-bed-drawer]');
  }

  function rowTemplate(row) {
    return row.querySelector('template[data-fi-bed-tpl]');
  }

  /* The drawer ships inside a <template> so it costs the page load nothing. It is
     stamped into the row the first time it is opened, and stays there. */
  function stamp(row) {
    var dialog = rowDialog(row);
    if (dialog) return dialog;
    var tpl = rowTemplate(row);
    if (!tpl) return null;
    row.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
    return rowDialog(row);
  }

  /* The options are read from the drawer once it exists, and from the inert template
     before that — restoring a choice after a variant change must not build a drawer
     nobody has opened. */
  function radios(row) {
    var tpl = rowDialog(row) ? null : rowTemplate(row);
    var scope = tpl ? tpl.content : row;
    return Array.prototype.slice.call(scope.querySelectorAll('.fi-bed-item__radio'));
  }

  /* fi-pdp-bed-drawer.css loads without blocking render. A drawer opened before it
     has arrived switches it on rather than waiting for its onload. */
  function ensureDrawerStyles() {
    var sheet = document.querySelector('link[data-fi-bed-drawer-css]');
    if (sheet && sheet.media !== 'all') sheet.media = 'all';
  }

  function radioFor(row, productId) {
    return radios(row).filter(function (radio) {
      return radio.dataset.productId === String(productId || '');
    })[0];
  }

  function mainForm() {
    return document.querySelector('product-info form[data-type="add-to-cart-form"]');
  }

  /* ---- Linking the options to their bed in the basket ----
     The bed carries _fi_bed and each option _fi_option with the same token, so
     fi-bed-cart-guard.js can take an option out when its bed is removed. The bed's
     field is only enabled while something is chosen: a bed on its own stays one plain
     line that merges with the next add of the same bed. */
  function tokenInput() {
    var form = mainForm();
    if (!form) return null;
    var input = form.querySelector('[data-fi-bed-token]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_fi_bed]';
      input.setAttribute('data-fi-bed-token', '');
      input.disabled = true;
      form.appendChild(input);
    }
    return input;
  }

  function syncToken() {
    var input = tokenInput();
    var any = rows().some(function (row) {
      var box = rowInput(row);
      return box && box.checked && box.value;
    });
    if (input) {
      input.value = token;
      input.disabled = !any;
    }
    rows().forEach(function (row) {
      var box = rowInput(row);
      if (!box) return;
      var props = { _fi_option: token };
      props[row.dataset.noteLabel || 'For'] = row.dataset.bedLabel || '';
      box.setAttribute('data-fi-addon-props', JSON.stringify(props));
    });
  }

  /* ---- Writing a choice to the row ---- */
  function apply(row, radio) {
    var box = rowInput(row);
    if (!box) return;
    var picked = radio && radio.value;
    var price = picked ? parseInt(radio.dataset.price, 10) || 0 : 0;

    box.value = picked ? radio.value : '';
    box.dataset.price = String(price);
    box.checked = !!picked;
    chosen[row.dataset.fiBedOption] = picked ? radio.dataset.productId : '';

    var value = row.querySelector('[data-fi-bed-value]');
    var delta = row.querySelector('[data-fi-bed-delta]');
    var cta = row.querySelector('[data-fi-bed-cta]');
    if (value) value.textContent = picked ? radio.dataset.summary || radio.dataset.title : row.dataset.emptyValue || '';
    if (delta) delta.textContent = picked && price > 0 ? '+' + money(price, true) : '';
    if (cta) cta.textContent = picked ? row.dataset.ctaSelected : row.dataset.ctaEmpty;
    row.classList.toggle('is-empty', !picked);

    syncToken();
    /* Heard by fi-pdp-v5.js, which re-prices the buttons and the sticky bar. */
    box.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---- Drawer footer: this choice and what the bed comes to with it ---- */
  function refreshFooter(row) {
    var dialog = rowDialog(row);
    if (!dialog) return;
    var radio = dialog.querySelector('.fi-bed-item__radio:checked');
    var price = radio && radio.value ? parseInt(radio.dataset.price, 10) || 0 : 0;

    var total = parseInt(row.dataset.bedPrice, 10) || 0;
    rows().forEach(function (other) {
      if (other === row) return;
      var box = rowInput(other);
      if (box && box.checked && box.value) total += parseInt(box.dataset.price, 10) || 0;
    });
    total += price;

    var choice = dialog.querySelector('[data-fi-bed-choice]');
    if (choice) {
      choice.textContent = radio && radio.value
        ? radio.dataset.title + ' · +' + money(price)
        : row.dataset.noneTitle || '';
    }
    var slot = dialog.querySelector('[data-fi-bed-total]');
    if (slot) slot.textContent = money(total);
  }

  /* ---- Open / close ---- */
  var openRow = null;
  var openedAt = 0;
  var downOnBackdrop = false;

  /* instant: re-opening the freshly rendered drawer after a variant change, with no
     slide-in, so the customer only sees the prices change. */
  function open(row, instant) {
    ensureDrawerStyles();
    var dialog = stamp(row);
    if (!dialog) return;
    dialog.classList.toggle('is-instant', !!instant);
    openedAt = Date.now();
    /* The drawer opens on what is confirmed, not on whatever was last clicked inside
       it and then abandoned. */
    var current = radioFor(row, chosen[row.dataset.fiBedOption] || '') || radioFor(row, '');
    radios(row).forEach(function (radio) {
      radio.checked = radio === current;
    });
    refreshFooter(row);
    openRow = row;
    document.documentElement.classList.add('fi-bed-locked');
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    var focus = (current && !current.disabled ? current : null) || dialog.querySelector('[data-fi-bed-close]');
    if (focus) focus.focus({ preventScroll: true });
  }

  function close(row) {
    var dialog = row && rowDialog(row);
    if (dialog && dialog.open) {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }
  }

  /* The dimmed page beside the panel. A click there lands on the <dialog> itself, but
     so can one inside it while the drawer stylesheet is still on its way and the panel
     is not yet full height - so the point must also be outside the panel. */
  function onBackdrop(dialog, event) {
    if (event.target !== dialog) return false;
    var panel = dialog.querySelector('.fi-bed-drawer__panel');
    if (!panel) return true;
    var box = panel.getBoundingClientRect();
    return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
  }

  /* A backdrop click only counts when it also started on the backdrop: a press that
     began inside the panel (selecting text, a scroll on a touch screen) and ended
     outside it must not close the drawer. */
  document.addEventListener(
    'pointerdown',
    function (event) {
      var dialog = event.target.closest && event.target.closest('[data-fi-bed-drawer]');
      downOnBackdrop = !!dialog && onBackdrop(dialog, event);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;

    var opener = target.closest('[data-fi-bed-open]');
    if (opener) {
      event.preventDefault();
      var row = opener.closest('[data-fi-bed-option]');
      var already = row && rowDialog(row);
      if (row && !(already && already.open)) open(row);
      return;
    }

    var drawer = target.closest('[data-fi-bed-drawer]');
    if (!drawer) {
      var family = target.closest('[data-fi-bed-family]');
      if (family) pickFamily(family);
      return;
    }
    var owner = drawer.closest('[data-fi-bed-option]');

    if (target.closest('[data-fi-bed-close]')) {
      close(owner);
      return;
    }

    /* The tap that opened the drawer can be followed by a stray click on its backdrop
       (a touch screen's delayed click, a double click): ignored for a moment. */
    if (target === drawer) {
      if (downOnBackdrop && onBackdrop(drawer, event) && Date.now() - openedAt > 400) close(owner);
      downOnBackdrop = false;
      return;
    }

    if (target.closest('[data-fi-bed-confirm]')) {
      apply(owner, drawer.querySelector('.fi-bed-item__radio:checked'));
      var total = drawer.querySelector('[data-fi-bed-total]');
      if (total) announce((owner.dataset.totalLabel || 'Bed total') + ' ' + total.textContent);
      close(owner);
      return;
    }

    var filter = target.closest('[data-fi-bed-filter]');
    if (filter) {
      pickFilter(drawer, filter);
      return;
    }

    if (target.closest('[data-fi-bed-size-change]')) {
      close(owner);
      var size = document.querySelector('.fi-bed-field--size');
      if (size) {
        size.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var checked = size.querySelector('input:checked') || size.querySelector('input');
        if (checked) checked.focus({ preventScroll: true });
      }
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('.fi-bed-item__radio')) return;
    var row = event.target.closest('[data-fi-bed-option]');
    if (row) refreshFooter(row);
  });

  /* Esc and the close button both end here. Nothing is applied unless Confirm was
     pressed, so closing is always "keep what I had". */
  document.addEventListener(
    'close',
    function (event) {
      if (!event.target.matches || !event.target.matches('[data-fi-bed-drawer]')) return;
      /* The close event arrives a moment after the close. By then a variant change may
         have swapped the row and opened its new drawer: that one keeps the page locked,
         and focus is left where it is. */
      if (!document.querySelector('[data-fi-bed-drawer][open]')) {
        document.documentElement.classList.remove('fi-bed-locked');
      }
      var row = event.target.closest('[data-fi-bed-option]');
      if (row === openRow) openRow = null;
      if (!row || !row.isConnected || openRow) return;
      var opener = row.querySelector('[data-fi-bed-open]');
      if (opener) opener.focus({ preventScroll: true });
    },
    true
  );

  /* ---- Firmness filter inside the mattress drawer ---- */
  function pickFilter(drawer, button) {
    var want = button.getAttribute('data-fi-bed-filter');
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-fi-bed-filter]'), function (other) {
      other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
    });
    Array.prototype.forEach.call(drawer.querySelectorAll('.fi-bed-item'), function (item) {
      if (item.classList.contains('fi-bed-item--none')) return;
      item.hidden = !!want && item.dataset.firmness !== want;
    });
  }

  /* ---- Colour family pills: show that family's swatches ----
     Choosing a family does not change the colour. The customer picks a swatch for
     that, which is the theme's own variant change. */
  function pickFamily(button) {
    var field = button.closest('[data-fi-bed-colours]');
    if (!field) return;
    var want = button.getAttribute('data-fi-bed-family');
    Array.prototype.forEach.call(field.querySelectorAll('[data-fi-bed-family]'), function (other) {
      other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
    });
    Array.prototype.forEach.call(field.querySelectorAll('.fi-bed-swatch'), function (swatch) {
      var family = swatch.getAttribute('data-family');
      swatch.hidden = !!family && family !== want;
    });
  }

  /* ---- The new total, read out once a choice is confirmed ----
     The figure itself lives in the buttons, which are rewritten on every quantity tap;
     a live region there would talk over the customer. This says it once per choice. */
  var announcer = null;

  function announce(text) {
    if (!announcer) {
      announcer = document.createElement('p');
      announcer.className = 'visually-hidden';
      announcer.setAttribute('aria-live', 'polite');
      document.body.appendChild(announcer);
    }
    announcer.textContent = '';
    setTimeout(function () {
      announcer.textContent = text;
    }, 50);
  }

  /* ---- Add to Basket: the bed and its options in one call ----
     The theme's form would add the bed alone and fi-pdp-v5.js the options after it, in
     a second call that can fail on its own and leave the bed without them. On a bed
     page the form's submit is taken here instead and everything goes in together. It
     ends as product-form.js does: the drawer is rendered from the response and the
     add is announced as the form's own, so every listener behaves as before.
     fi-pdp-v5.js asks ownsAdd() and leaves its post-add pass empty while this runs. */
  function ownsAdd() {
    return !!mainForm() && rows().length > 0;
  }
  window.FIBed.ownsAdd = ownsAdd;

  function bedLine(form) {
    var data = new FormData(form);
    var line = { id: Number(data.get('id')), quantity: parseInt(data.get('quantity'), 10) || 1 };
    var properties = {};
    var any = false;
    data.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (match && value !== '' && typeof value === 'string') {
        properties[match[1]] = value;
        any = true;
      }
    });
    if (any) line.properties = properties;
    var plan = data.get('selling_plan');
    if (plan) line.selling_plan = Number(plan);
    return line;
  }

  function optionLines(quantity) {
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-fi-addon]:checked'))
      .filter(function (input) {
        return input.value;
      })
      .map(function (input) {
        var line = {
          id: Number(input.value),
          quantity: input.hasAttribute('data-fi-addon-scales') ? quantity : 1
        };
        var raw = input.getAttribute('data-fi-addon-props');
        if (raw) {
          try {
            line.properties = JSON.parse(raw);
          } catch (e) {}
        }
        return line;
      });
  }

  function addTogether(form) {
    var host = form.closest('product-form');
    var button = form.querySelector('[type="submit"]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    var spinner = host && host.querySelector('.loading__spinner');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var showError = function (message) {
      if (host && typeof host.handleErrorMessage === 'function') host.handleErrorMessage(message);
    };

    var bed = bedLine(form);
    if (!bed.id) return;

    showError();
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    var payload = { items: [bed].concat(optionLines(bed.quantity)) };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) {
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: bed.id,
              errors: state.errors || state.description,
              message: state.message
            });
          }
          showError(state.description || state.message);
          return;
        }
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || root + 'cart';
          return;
        }
        /* A subscriber that throws must not keep the drawer from showing the bed. */
        try {
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: bed.id, cartData: state });
          }
        } catch (e) {
          console.error(e);
        }
        cart.renderContents(state);
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
  }

  /* Capture phase on the document runs before product-form.js's own listener on the
     form, and stopping it there means that listener never sees this submit. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form !== mainForm() || !ownsAdd()) return;
      event.preventDefault();
      event.stopPropagation();
      addTogether(form);
    },
    true
  );

  /* ---- Variant change: swap in the rows priced for the new size, keep the choices ----
     product-info.js only refreshes the theme's own regions. The option rows carry
     per-size prices, so they are taken from the same section HTML it fetched. */
  function restore(row) {
    var id = chosen[row.dataset.fiBedOption];
    if (!id) {
      syncToken();
      return;
    }
    var radio = radioFor(row, id);
    /* Not made in the new size, or sold out in it: the choice is dropped rather than
       silently swapped for something else. */
    apply(row, radio && !radio.disabled ? radio : null);
  }

  /* product-info.js ends every variant change with toggleSubmitButton(), which sets the
     Add to Basket label to the bare locale string and so wipes the icon and the price
     slot inside it. The button as the new variant renders it is in the same HTML, so its
     contents are put back, and fi-pdp-v5.js is asked to re-price it with the options. */
  function restoreSubmit(html, sectionId) {
    var form = mainForm();
    var button = form && form.querySelector('[type="submit"]');
    if (!button || !button.id) return;
    var fresh = (sectionId && html.getElementById('ProductSubmitButton-' + sectionId)) || html.getElementById(button.id);
    if (!fresh || fresh.hasAttribute('disabled')) return;
    var label = button.querySelector('span');
    var freshLabel = fresh.querySelector('span');
    if (label && freshLabel) label.innerHTML = freshLabel.innerHTML;
    var box = document.querySelector('[data-fi-addon]');
    if (box) box.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onVariantChange(event) {
    var html = event && event.data && event.data.html;
    if (!html) return;
    restoreSubmit(html, event.data.sectionId);
    rows().forEach(function (row) {
      var fresh = html.getElementById(row.id);
      if (!fresh) return;
      /* A drawer open while the new prices arrive stays open: the fresh one is shown
         in its place, without the slide-in. */
      var reopen = row === openRow && rowDialog(row) && rowDialog(row).open;
      if (reopen) {
        close(row);
        openRow = null;
      }
      var node = document.importNode(fresh, true);
      row.replaceWith(node);
      restore(node);
      if (reopen) open(node, true);
    });
  }

  (function watch() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(watch, 300);
      return;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    /* Once the bed and its options are in, the next bed added from this page is a new
       set, with its own token. */
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form') {
        token = newToken();
        syncToken();
      }
    });
  })();

  function init() {
    syncToken();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
